import useSWR from 'swr';

import { servicesAPI } from '../services_api';

export function useUsers() {
  const { data = [] } = useSWR(`users`, () =>
    servicesAPI.CustomerServices('users')
  );

  return data;
}

export function useCustomers() {
  const { data = [] } = useSWR(`customers`, () =>
    servicesAPI.CustomerServices()
  );

  return data;
}

export function useCustomersVehicles() {
  const { data = [] } = useSWR(`customersVehicles`, () =>
    servicesAPI.CustomerServices('getCustomersVehicles')
  );

  return data;
}

export function useHydras() {
  const { data = [] } = useSWR(`getHydras`, () =>
    servicesAPI.InventoryServices('getHydras')
  );

  return data;
}

export function useHydra(id) {
  const { data = null } = useSWR(id ? `getHydra/${id}` : null, () =>
    servicesAPI.InventoryServices('getHydra', id, false)
  );

  return data;
}

export function useServiceStatuses() {
  const { data = [] } = useSWR(`getServiceStatuses`, () =>
    servicesAPI.AdminServices('getServiceStatuses')
  );

  return data;
}

export function useWeather(hydra_tag_id, timestamp) {
  const { data = [] } = useSWR(`getWeather/${hydra_tag_id}/${timestamp}`, () =>
    servicesAPI.AdminServices('getWeather', hydra_tag_id, timestamp)
  );

  return data;
}
